import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    resourceName: String,
    resourcePath: String
  }

  connect() {
  }

  disconnect() {
  }

  openModal(event) {
    // Prevent default behavior and stop propagation
    event.preventDefault()
    event.stopPropagation()
    
    const modalId = event.currentTarget.dataset.modalId || "deleteModal"
    const modal = document.getElementById(modalId)
    
    if (!modal) {
      console.error("Modal not found:", modalId)
      return
    }

    // Setup modal content
    this.setupModal(event)
    
    // Open the modal
    modal.classList.remove('hidden')
    
    // Dispatch a modal opened event
    modal.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }))
  }

  setupModal(event) {
    const modalId = event.currentTarget.dataset.modalId || "deleteModal"
    const modal = document.getElementById(modalId)
    if (!modal) return

    // Update the resource name in the confirmation message
    const resourceNameElement = modal.querySelector("#deleteResourceName")
    if (resourceNameElement) {
      resourceNameElement.textContent = this.resourceNameValue
    }

    // Update the form action
    const form = modal.querySelector("#deleteForm")
    if (form) {
      form.action = this.resourcePathValue
    }
  }
} 
